/* Lingo Light (Oct 2026): Lingo's own scripts, moved out of the inline <script> tags in the snippets/sections named below
   so they're cached once instead of re-sent in every page's HTML. Loaded with defer in <head> (runs after the HTML is parsed,
   before reach.js, in the same order the inline scripts used to run). Each module runs only if its markup is on the page and
   is isolated, so one failing can't stop the others. No Liquid inside: per-page data stays inline (e.g. #lingo-cd-data). */
(function () {
  function run(name, need, fn) { if (need && !document.querySelector(need)) return; try { fn(); } catch (e) { if (window.console) console.error('[lingo.js] ' + name, e); } }

  /* ---- nav-lazy (was inline in snippets/lingo-nav-panel.liquid) ---- */
  run('nav-lazy', null, function () {
    (function () {
      /* Lingo Light: lazy menu tiles. Every deck grid in the desktop mega menu and the phone drawer ships as skeleton tiles
         ([data-lingo-lazy="<panel>"]); the real tiles come from one Section Rendering API request per panel
         (/?section_id=lingo-nav-<panel>, or lingo-all-decks), started on first intent (hover, focus, pointerdown/touch on the
         panel's tab or pill, or opening the phone drawer) and filled into a grid only when its panel is shown. Desktop and phone
         share the same response, so each deck list is fetched once. Responses are kept in sessionStorage for 10 minutes per
         country + currency (prices and the Met rule depend on them). window.LingoNavLazy.get(panel) returns the HTML. */
      if (window.LingoNavLazy) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var SEC = { heritage: 'lingo-nav-heritage', travel: 'lingo-nav-travel', gifts: 'lingo-nav-gifts', fun: 'lingo-nav-fun', met: 'lingo-nav-met', all: 'lingo-all-decks' };
      var reqs = {}, TTL = 600000;
      function ckey(k) { var S = window.Shopify || {}; return 'lingoNav:v1:' + k + ':' + (S.country || '') + ':' + ((S.currency && S.currency.active) || '') + ':' + ((S.theme && S.theme.id) || ''); }
      function parse(k, t) {
        var d = document.createElement('div'); d.innerHTML = t;
        var lists = k === 'all' ? d.querySelectorAll('[data-lingo-all-list]') : d.querySelectorAll('[data-lingo-grid]');
        if (!lists.length) throw new Error('empty');
        return Array.prototype.map.call(lists, function (u) { return u.innerHTML; });
      }
      function get(k) {
        if (!SEC[k]) return Promise.reject(new Error('panel'));
        if (reqs[k]) return reqs[k];
        try { var c = JSON.parse(sessionStorage.getItem(ckey(k)) || 'null'); if (c && Date.now() - c.t < TTL && c.h && c.h.length) return (reqs[k] = Promise.resolve(c.h)); } catch (e) {}
        reqs[k] = fetch(root + '?section_id=' + SEC[k], { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) {
          var h = parse(k, t);
          try { sessionStorage.setItem(ckey(k), JSON.stringify({ t: Date.now(), h: h })); } catch (e) {}
          return h;
        });
        reqs[k].catch(function () { reqs[k] = null; });
        return reqs[k];
      }
      function grids(scope, k) {
        var sel = k === 'all' ? '[data-lingo-all-grid]:not([data-loaded])' : '[data-lingo-lazy="' + k + '"]:not([data-loaded])';
        return Array.prototype.slice.call(scope.querySelectorAll(sel));
      }
      function fill(scope, k) {
        var gs = grids(scope, k); if (!gs.length) return;
        get(k).then(function (h) {
          gs.forEach(function (g, i) {
            if (g.hasAttribute('data-loaded')) return;
            g.innerHTML = k === 'all' ? h[0] : (h[i] != null ? h[i] : '');
            g.setAttribute('data-loaded', '');
            var w = g.closest('[data-lingo-all-wrap]'); if (w) { w.setAttribute('aria-busy', 'false'); var s = w.querySelector('[data-lingo-all-status]'); if (s) s.textContent = g.children.length + ' decks loaded'; }
          });
          document.dispatchEvent(new CustomEvent('lingo:nav-tiles-loaded', { detail: { panel: k } }));
          if (k === 'all') document.dispatchEvent(new CustomEvent('lingo:all-decks-loaded'));
        }).catch(function () {
          gs.forEach(function (g) {
            if (g.hasAttribute('data-loaded')) return;
            var href = k === 'all' ? '/collections/all' : ((g.closest('.lingo-panel') || document).querySelector('.lingo-panel__all') || { getAttribute: function () { return '/collections/all'; } }).getAttribute('href');
            g.innerHTML = '<li class="lingo-allgrid__err">Couldn\u2019t load the decks just now. <a href="' + href + '">See the decks</a></li>';
            var w = g.closest('[data-lingo-all-wrap]'); if (w) w.setAttribute('aria-busy', 'false');
          });
        });
      }
      function keyOf(el) {
        var a = el.getAttribute('aria-controls') || '', m = a.match(/^lingo-(?:mega|drawer)-([a-z]+)$/);
        if (m) return m[1];
        var s = el.getAttribute('data-lingo-strip-open'); return s || null;
      }
      function intent(e) {
        var t = e.target; if (!t || !t.closest) return;
        var tr = t.closest('[data-lingo-mega-trigger], [data-lingo-acc], [data-lingo-strip-open]'); if (!tr) return;
        var k = keyOf(tr);
        if (k && SEC[k]) { get(k).catch(function () {}); return; }
        /* Menu button / a pill opens the whole phone drawer: warm every panel shown in it */
        if (tr.hasAttribute('data-lingo-strip-open')) Object.keys(SEC).forEach(function (x) { if (document.getElementById('lingo-drawer-' + x)) get(x).catch(function () {}); });
      }
      ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach(function (ev) { document.addEventListener(ev, intent, { passive: true, capture: true }); });
      function watch() {
        Object.keys(SEC).forEach(function (k) {
          ['lingo-mega-' + k, 'lingo-drawer-' + k].forEach(function (id) {
            var el = document.getElementById(id); if (!el) return;
            if (!el.hidden) fill(el, k);
            new MutationObserver(function () { if (!el.hidden) fill(el, k); }).observe(el, { attributes: true, attributeFilter: ['hidden'] });
          });
        });
      }
      window.LingoNavLazy = { get: get, fill: fill };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    })();
  });

  /* ---- nav (was inline in snippets/lingo-nav-script.liquid) ---- */
  run('nav', null, function () {
(function () {
  if (window.__lingoNav) return; window.__lingoNav = true;
  var desk = window.matchMedia('(min-width: 1025px)'); /* Oct 11: match Reach's 1025px desktop breakpoint */
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  /* ---------- Desktop mega menu ---------- */
  var mega = document.querySelector('[data-lingo-mega]');
  if (mega) {
    var triggers = Array.prototype.slice.call(mega.querySelectorAll('[data-lingo-mega-trigger]'));
    var openBtn = null, tOpen, tClose;
    function panelOf(b) { return document.getElementById(b.getAttribute('aria-controls')); }
    function close(focusBack) {
      if (!openBtn) return;
      var b = openBtn; openBtn = null;
      b.setAttribute('aria-expanded', 'false'); panelOf(b).hidden = true;
      mega.classList.remove('is-open');
      if (focusBack) b.focus();
    }
    function open(b) {
      if (openBtn === b) return;
      if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); panelOf(openBtn).hidden = true; }
      openBtn = b; b.setAttribute('aria-expanded', 'true'); panelOf(b).hidden = false;
      mega.classList.add('is-open');
    }
    triggers.forEach(function (b, i) {
      b.addEventListener('click', function () { if (openBtn === b) close(false); else open(b); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' && openBtn === b) { e.preventDefault(); var f = panelOf(b).querySelector(FOCUSABLE); if (f) f.focus(); }
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); var n = triggers[(i + (e.key === 'ArrowRight' ? 1 : triggers.length - 1)) % triggers.length]; n.focus(); if (openBtn) open(n);
        }
      });
      b.parentNode.addEventListener('mouseenter', function () {
        if (!hoverable.matches) return; clearTimeout(tClose); clearTimeout(tOpen);
        tOpen = setTimeout(function () { open(b); }, openBtn ? 0 : 140);
      });
    });
    mega.addEventListener('mouseleave', function () { if (!hoverable.matches) return; clearTimeout(tOpen); tClose = setTimeout(function () { close(false); }, 220); });
    mega.addEventListener('mouseenter', function () { clearTimeout(tClose); });
    mega.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openBtn) { e.preventDefault(); close(true); } });
    mega.addEventListener('focusout', function (e) { if (openBtn && e.relatedTarget && !mega.contains(e.relatedTarget)) close(false); });
    document.addEventListener('click', function (e) { if (openBtn && !mega.contains(e.target)) close(false); });
    desk.addEventListener && desk.addEventListener('change', function () { close(false); });
  }

  /* ---------- Full-screen drawer (< 1024px) ---------- */
  var drawer = document.querySelector('[data-lingo-drawer]');
  var lastFocus = null;
  function drawerOpen(section) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('lingo-drawer-open');
    var menuBtn = document.querySelector('[data-header-drawer-toggle="menu"]');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    var target = drawer.querySelector('[data-lingo-drawer-close]');
    if (section) {
      // opened from a category pill: expand just that section and bring it to the top
      drawer.querySelectorAll('[data-lingo-acc]').forEach(function (b) {
        var on = b.getAttribute('aria-controls') === 'lingo-drawer-' + section;
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        document.getElementById(b.getAttribute('aria-controls')).hidden = !on;
        if (on) target = b;
      });
    }
    requestAnimationFrame(function () {
      if (section && target) { var body = drawer.querySelector('.lingo-drawer__body'); body.scrollTop = target.offsetTop - body.offsetTop - 8; }
      if (target) target.focus({ preventScroll: !!section });
    });
  }
  function drawerClose() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('lingo-drawer-open');
    var menuBtn = document.querySelector('[data-header-drawer-toggle="menu"]');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer) {
    // Take over the theme's Menu and Search buttons (and the category pills) before the theme's own handlers run.
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var pill = e.target.closest('[data-lingo-strip-open]');
      if (pill) { e.preventDefault(); drawerOpen(pill.getAttribute('data-lingo-strip-open')); return; }
      var t = e.target.closest('[data-header-drawer-toggle="menu"], [data-header-drawer-toggle="search"], [data-lingo-search-open]');
      if (!t) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (t.getAttribute('data-header-drawer-toggle') === 'menu') { if (drawer.hidden) drawerOpen(); else drawerClose(); }
      else { drawerClose(); overlayOpen(t); }
    }, true);
    drawer.querySelector('[data-lingo-drawer-close]').addEventListener('click', drawerClose);
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); drawerClose(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(drawer.querySelectorAll(FOCUSABLE)).filter(visible);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    drawer.querySelectorAll('[data-lingo-acc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = document.getElementById(b.getAttribute('aria-controls'));
        var o = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', o ? 'false' : 'true'); p.hidden = o;
      });
    });
    drawer.addEventListener('click', function (e) { if (e.target.closest('a[href]')) { document.documentElement.classList.remove('lingo-drawer-open'); } });
    desk.addEventListener && desk.addEventListener('change', function (m) { if (m.matches) drawerClose(); });
  }

  /* ---------- Search overlay (search icon by the cart, phone header icon, bottom-bar Search) ---------- */
  var overlay = document.querySelector('[data-lingo-soverlay]');
  var overlayFrom = null;
  function overlayOpen(from) {
    if (!overlay) return;
    overlayFrom = from || document.activeElement;
    overlay.hidden = false;
    document.documentElement.classList.add('lingo-soverlay-open');
    document.querySelectorAll('[data-header-drawer-toggle="search"], [data-lingo-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var inp = overlay.querySelector('.lingo-search__input');
    requestAnimationFrame(function () { if (inp) inp.focus(); });
  }
  function overlayClose() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.documentElement.classList.remove('lingo-soverlay-open');
    document.querySelectorAll('[data-header-drawer-toggle="search"], [data-lingo-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (overlayFrom && overlayFrom.focus) overlayFrom.focus();
  }
  if (overlay) {
    overlay.querySelector('[data-lingo-soverlay-close]').addEventListener('click', overlayClose);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlayClose(); });
    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); overlayClose(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(overlay.querySelectorAll(FOCUSABLE)).filter(visible);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Category strip edge fades ---------- */
  document.querySelectorAll('[data-lingo-strip]').forEach(function (nav) {
    var list = nav.querySelector('.lingo-strip__list');
    function upd() {
      nav.classList.toggle('is-scrolled', list.scrollLeft > 4);
      nav.classList.toggle('is-end', list.scrollLeft + list.clientWidth >= list.scrollWidth - 4);
    }
    list.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  });

  /* ---------- Predictive search ---------- */
  function lingoBindSearch() { document.querySelectorAll('[data-lingo-search]:not([data-lingo-bound])').forEach(function (form) { form.setAttribute('data-lingo-bound', '');
    var input = form.querySelector('.lingo-search__input');
    var pop = form.querySelector('[data-lingo-search-pop]');
    var list = form.querySelector('[role="listbox"]');
    var status = form.querySelector('[data-lingo-search-status]');
    var url = form.getAttribute('data-suggest-url') || '/search/suggest';
    var fmt = form.getAttribute('data-money-format') || ('$' + '{' + '{amount}' + '}');
    var timer, ctl, active = -1, items = [];
    function money(v) {
      var n = parseFloat(v); if (isNaN(n)) return '';
      var a = n.toFixed(2).replace(/\.00$/, '');
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, a);
    }
    function show(b) { pop.hidden = !b; input.setAttribute('aria-expanded', b ? 'true' : 'false'); if (!b) { active = -1; input.removeAttribute('aria-activedescendant'); } }
    function setActive(i) {
      items.forEach(function (li, j) { li.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      active = i;
      if (i > -1) { input.setAttribute('aria-activedescendant', items[i].id); items[i].scrollIntoView({ block: 'nearest' }); } else input.removeAttribute('aria-activedescendant');
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function render(q, res) {
      var notUS = form.getAttribute('data-us') === '0';
      var prods = (res.products || []).filter(function (p) { if (notUS && (p.type === 'Met Deck' || (p.tags || []).indexOf('TheMet') > -1)) return false; return p.available !== false && p.handle !== 'shipping-protection' && !/shipping protection/i.test((p.title || '') + ' ' + (p.type || '')); }).slice(0, 6);
      var cols = (res.collections || []).slice(0, 3);
      var html = '', k = 0, base = list.id;
      prods.forEach(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        html += '<li class="lingo-search__opt" role="option" id="' + base + '-' + (k++) + '" aria-selected="false" data-href="' + esc(p.url) + '">' +
          '<a href="' + esc(p.url) + '" tabindex="-1">' + (img ? '<img src="' + esc(img) + '" width="48" height="48" alt="" loading="lazy">' : '<span class="lingo-search__noimg"></span>') +
          '<span class="lingo-search__t">' + esc(p.title) + '</span><span class="lingo-search__p">' + esc(money(p.price)) + '</span></a></li>';
      });
      cols.forEach(function (c) {
        html += '<li class="lingo-search__opt lingo-search__opt--col" role="option" id="' + base + '-' + (k++) + '" aria-selected="false" data-href="' + esc(c.url) + '"><a href="' + esc(c.url) + '" tabindex="-1"><span class="lingo-search__t">Collection: ' + esc(c.title) + '</span></a></li>';
      });
      html += '<li class="lingo-search__opt lingo-search__opt--all" role="option" id="' + base + '-' + (k++) + '" aria-selected="false" data-href="/search?type=product&q=' + encodeURIComponent(q) + '"><a href="/search?type=product&q=' + encodeURIComponent(q) + '" tabindex="-1"><span class="lingo-search__t">See all results for \u201c' + esc(q) + '\u201d</span></a></li>';
      list.innerHTML = html;
      items = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
      status.textContent = prods.length ? prods.length + ' products found' : 'No products found. Press Enter to search.';
      setActive(-1); show(true);
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { show(false); list.innerHTML = ''; items = []; return; }
      if (ctl) ctl.abort();
      ctl = 'AbortController' in window ? new AbortController() : null;
      fetch(url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=hide', { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (input.value.trim() === q) render(q, (d.resources && d.resources.results) || {}); })
        .catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 200); });
    input.addEventListener('focus', function () { if (items.length && input.value.trim().length > 1) show(true); });
    input.addEventListener('keydown', function (e) {
      if (pop.hidden || !items.length) return; // Esc with no results open falls through and closes the overlay/drawer
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive((active + 1) % items.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active <= 0 ? items.length - 1 : active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); window.location.href = items[active].getAttribute('data-href'); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); show(false); }
    });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) { var o = e.target.closest('[role="option"]'); if (o) window.location.href = o.getAttribute('data-href'); });
    form.addEventListener('focusout', function (e) { if (!e.relatedTarget || !form.contains(e.relatedTarget)) setTimeout(function () { if (!form.contains(document.activeElement)) show(false); }, 0); });
  }); }
  // bind now (header forms) and again once the page is parsed (search boxes further down, e.g. 404 / empty cart)
  lingoBindSearch(); document.addEventListener('DOMContentLoaded', lingoBindSearch);
})();

/* Peak 2026: country/region selector auto-submit */
document.addEventListener('change',function(e){var t=e.target;if(t&&t.matches&&t.matches('[data-lingo-loc]')&&t.form){t.form.submit();}});
  });

  /* ---- quick-add (was inline in snippets/lingo-qa-script.liquid) ---- */
  run('quick-add', null, function () {
(function () {
  if (window.__lingoQA) return; window.__lingoQA = true;
  var status = document.getElementById('lingo-qa-status');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var quiet = 0;
  var queue = Promise.resolve(), pending = 0, settleT;
  function post(url, body) { return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }); }
  function addOne(id) { quiet++; return post('/cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); }).finally(function () { quiet--; }); }
  function sync() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count > 0 ? c.item_count : ''; });
      if (window.LingoCart) { try { window.LingoCart.refresh(); } catch (e) {} }
      return c;
    }).catch(function () {});
  }
  function ensureTrio(c) {
    if (!c) return;
    var n = 0; (c.items || []).forEach(function (it) { if (it.product_type !== 'Met Deck') n += it.quantity; });
    if (n >= 3 && !(c.discount_codes && c.discount_codes.length)) return post('/cart/update.js', { discount: 'TravelTrio' }).catch(function () {});
  }
  function cartIcon() {
    var c = Array.prototype.slice.call(document.querySelectorAll('[data-lingo-cart]')).concat(Array.prototype.slice.call(document.querySelectorAll('[data-header-drawer-toggle="cart"]')));
    for (var i = 0; i < c.length; i++) { var r = c[i].getBoundingClientRect(); if (r.width && r.height && r.bottom > 0 && r.top < window.innerHeight && onTop(c[i], r)) return c[i]; }
    return null;
  }
  /* Oct 11: skip a cart icon that's covered (e.g. the phone header cart under the open full-screen menu) */
  function onTop(el, r) { var h = document.elementFromPoint(r.left + r.width / 2, Math.max(1, Math.min(window.innerHeight - 1, r.top + r.height / 2))); return !h || el === h || el.contains(h); }
  function fly(btn) {
    var t = cartIcon(); if (reduce.matches || !t || !document.body.animate) return;
    var a = btn.getBoundingClientRect(), b = t.getBoundingClientRect();
    var dot = document.createElement('span'); dot.className = 'lingo-fly'; dot.setAttribute('aria-hidden', 'true');
    var card = btn.closest('.lingo-qa__item'), img = card && card.querySelector('[data-fly-img]'); if (img && img.currentSrc) dot.style.backgroundImage = 'url("' + img.currentSrc + '")';
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2, dx = b.left + b.width / 2 - x0, dy = b.top + b.height / 2 - y0;
    dot.style.left = x0 + 'px'; dot.style.top = y0 + 'px'; document.body.appendChild(dot);
    var an = dot.animate([{ transform: 'translate(0,0) scale(1)' }, { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 + Math.min(-60, dy / 3)) + 'px) scale(.85)', offset: .5 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.35)', opacity: .6 }], { duration: 650, easing: 'cubic-bezier(.4,0,.2,1)' });
    an.onfinish = an.oncancel = function () { dot.remove(); };
  }
  /* Oct 11: smooth "Added" confirmation. The label is never rewritten: a check + "Added" layer fades in over it (same size, no reflow)
     while the button turns green, then both fade back together. Taps on a button that is adding or confirming are ignored, so
     rapid taps can't stack adds or leave the button stuck on "Added". */
  function okOn(b) {
    var o = b.querySelector('.lingo-qa__ok');
    if (!o) { o = document.createElement('span'); o.className = 'lingo-qa__ok'; o.setAttribute('aria-hidden', 'true'); o.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" focusable="false"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>Added'; b.appendChild(o); }
    b.classList.add('is-added');
    clearTimeout(b._t); b._t = setTimeout(function () { b.classList.remove('is-added'); b._t = setTimeout(function () { okOff(b); }, 220); }, 1300);
  }
  function okOff(b) { b._lq = false; b.removeAttribute('aria-disabled'); }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[data-lingo-qa-add]'); if (!btn) return;
    e.preventDefault();
    if (btn._lq) return; btn._lq = true; btn.setAttribute('aria-disabled', 'true');
    pending++; var id = parseInt(btn.getAttribute('data-variant'), 10), title = btn.getAttribute('data-title') || 'Item';
    btn.setAttribute('aria-busy', 'true'); fly(btn);
    /* Oct 13: fast path. The green check shows on the tap; LingoCart.add() does the add (+ TravelTrio when it makes 3) in ONE request
       and keeps the drawer's cart from the reply, so there are no follow-up cart reads. Failure: check undone, old path below. */
    if (window.LingoCart && LingoCart.add) {
      okOn(btn);
      var card = btn.closest('.lingo-qa__item, article, li'), im = card && card.querySelector('[data-fly-img]');
      LingoCart.add([{ v: id, q: 1, t: title, y: card && card.querySelector('.lingo-qa__note') ? 'Met Deck' : '', i: im && im.currentSrc }], { quiet: true }).then(function () {
        if (status) status.textContent = title + ' added to your cart.';
      }, function () {
        clearTimeout(btn._t); btn.classList.remove('is-added');
        return addOne(id).then(function () { okOn(btn); if (status) status.textContent = title + ' added to your cart.'; return sync().then(ensureTrio).then(sync); }, function () { okOff(btn); if (status) status.textContent = 'Sorry, ' + title + ' could not be added. Please try again.'; });
      }).then(function () { btn.removeAttribute('aria-busy'); pending--; });
      return;
    }
    queue = queue.then(function () { return addOne(id); }).then(function () {
      okOn(btn);
      if (status) status.textContent = title + ' added to your cart.'; sync();
    }, function () { okOff(btn); if (status) status.textContent = 'Sorry, ' + title + ' could not be added. Please try again.'; })
    .then(function () { btn.removeAttribute('aria-busy'); pending--;
      clearTimeout(settleT); settleT = setTimeout(function () { if (pending) return; queue = queue.then(sync).then(ensureTrio).then(sync); }, 900);
    });
  });
})();
  });

  /* ---- surprise (was inline in snippets/lingo-surprise.liquid) ---- */
  /* Oct 13: "Surprise me" adds 3 different random in-stock decks (Buy 2, get 1 free) and opens the cart drawer.
     Fast path: the pool is rendered into #lingo-cd-data ("surprise") with the page, and LingoCart.surprise() opens the drawer
     instantly and does the add + TravelTrio in one request. Fallback (no pool or no drawer): /products.json, add, code, /cart page. */
  run('surprise', null, function () {
(function () {
  if (window.__lingoSurprise) return; window.__lingoSurprise = true;
  var TYPES = { 'Language Deck': 1, 'Slang Deck': 1, 'Wellness Deck': 1, 'Street Food Deck': 1 };
  var poolP = null, busy = false;
  function chip() {
    var row = document.querySelector('.lingo-shopall__filters'), src = document.querySelector('[data-lingo-surprise]');
    if (!row || !src || row.querySelector('[data-lingo-surprise]')) return;
    var b = src.cloneNode(true); b.classList.remove('lingo-surprise--menu'); row.insertBefore(b, row.children[1] || null);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', chip); else chip();
  function json(url, body) {
    var o = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(body); }
    return fetch(url, o).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function embedded() {
    try { var d = JSON.parse(document.getElementById('lingo-cd-data').textContent); return (d.surprise || []).filter(function (p) { return p && p.v && TYPES[p.y] && !/the-met/.test(p.h || ''); }); } catch (e) { return []; }
  }
  function pool() {
    var e = embedded(); if (e.length >= 3) return Promise.resolve(e);
    if (!poolP) poolP = json('/products.json?limit=250').then(function (d) {
      var out = [];
      (d.products || []).forEach(function (p) {
        if (!TYPES[p.product_type] || /the-met/.test(p.handle)) return;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        if (v) out.push({ v: v.id, t: p.title, y: p.product_type, h: p.handle, u: '/products/' + p.handle, p: Math.round(parseFloat(v.price) * 100), i: p.images && p.images[0] && p.images[0].src });
      });
      return out;
    }).catch(function (e) { poolP = null; throw e; });
    return poolP;
  }
  function pick(list, n) {
    var a = list.slice(), r = [];
    while (a.length && r.length < n) r.push(a.splice(Math.floor(Math.random() * a.length), 1)[0]);
    return r;
  }
  function say(m) { var s = document.getElementById('lingo-qa-status'); if (s) s.textContent = m; }
  function setBusy(on) { document.querySelectorAll('[data-lingo-surprise]').forEach(function (x) { if (on) x.setAttribute('aria-busy', 'true'); else x.removeAttribute('aria-busy'); }); }
  function slow(picks) {
    return json('/cart/add.js', { items: picks.map(function (p) { return { id: p.v, quantity: 1 }; }) }).then(function () { return json('/cart.js'); }).then(function (c) {
      var n = 0; (c.items || []).forEach(function (it) { if (it.product_type !== 'Met Deck' && !/shipping protection/i.test(it.product_type)) n += it.quantity; });
      if (n >= 3 && !(c.discount_codes && c.discount_codes.length)) return json('/cart/update.js', { discount: 'TravelTrio' }).catch(function () {});
    }).then(function () {
      if (window.LingoCart && LingoCart.open) LingoCart.open(); else location.href = '/cart';
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lingo-surprise]'); if (!b) return;
    e.preventDefault();
    if (busy) return; busy = true; setBusy(true);
    var picks;
    pool().then(function (list) {
      picks = pick(list, 3);
      if (picks.length < 3) throw new Error('pool');
      if (window.LingoCart && LingoCart.surprise) return LingoCart.surprise(picks).catch(function () { return slow(picks); });
      return slow(picks);
    }).then(function () {
      say(picks.map(function (p) { return p.t; }).join(', ') + ' added to your cart. One of them is free.');
    }).catch(function () {
      say('Sorry, we could not add your surprise decks. Please try again.');
      location.href = '/collections/all';
    }).then(function () { busy = false; setBusy(false); });
  });
})();
  });

  /* ---- shop-all (was inline in sections/lingo-shop-all.liquid) ---- */
  run('shop-all', '[data-lingo-shopall]', function () {
(function () {
  var root = document.querySelector('[data-lingo-shopall]:not([data-ready])'); if (!root) return; root.setAttribute('data-ready', '');
  var items = Array.prototype.slice.call(root.querySelectorAll('.lingo-shopall__item'));
  var filters = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
  var more = root.querySelector('[data-lingo-shopall-more]');
  var status = root.querySelector('[data-lingo-shopall-status]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var expanded = false, cur = 'all';
  function apply() {
    var n = 0;
    items.forEach(function (li) {
      var match = cur === 'all' || li.getAttribute('data-cat') === cur;
      var showIt = match && (expanded || cur !== 'all' || !li.hasAttribute('data-more'));
      li.hidden = !showIt; if (showIt) n++;
    });
    if (more) { more.parentNode.hidden = cur !== 'all' || expanded; }
    status.textContent = n + ' products shown';
  }
  filters.forEach(function (b) {
    b.addEventListener('click', function () {
      cur = b.getAttribute('data-filter');
      filters.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      apply();
    });
  });
  if (more) more.addEventListener('click', function () { expanded = true; more.setAttribute('aria-expanded', 'true'); apply(); });

  var quiet = 0;
  var queue = Promise.resolve();
  function addOne(id) {
    quiet++;
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .finally(function () { quiet--; });
  }
  var syncTimer;
  function syncCart() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count > 0 ? cart.item_count : ''; });
        if (window.LingoCart) { try { window.LingoCart.refresh(); } catch (e) {} }
      }).catch(function () {});
    }, 250);
  }
  function cartIcon() {
    // prefer the phone header cart (data-lingo-cart), then the theme header cart; the first one actually on screen wins
    var c = Array.prototype.slice.call(document.querySelectorAll('[data-lingo-cart]')).concat(Array.prototype.slice.call(document.querySelectorAll('[data-header-drawer-toggle="cart"]')));
    for (var i = 0; i < c.length; i++) { var r = c[i].getBoundingClientRect(); if (r.width && r.height && r.bottom > 0 && r.top < window.innerHeight && onTop(c[i], r)) return c[i]; }
    return null;
  }
  /* Oct 11: skip a cart icon that's covered (e.g. the phone header cart under the open full-screen menu) */
  function onTop(el, r) { var h = document.elementFromPoint(r.left + r.width / 2, Math.max(1, Math.min(window.innerHeight - 1, r.top + r.height / 2))); return !h || el === h || el.contains(h); }
  function bump() {
    var t = cartIcon(); if (!t || reduce.matches) return;
    var el = t.querySelector('.site-header-action-icon') || t;
    el.classList.remove('lingo-cart-bump'); void el.offsetWidth; el.classList.add('lingo-cart-bump');
  }
  function fly(btn) {
    var t = cartIcon();
    if (reduce.matches || !t || !document.body.animate) { return Promise.resolve(); }
    var from = btn.getBoundingClientRect(), to = t.getBoundingClientRect();
    var dot = document.createElement('span'); dot.className = 'lingo-fly'; dot.setAttribute('aria-hidden', 'true');
    var img = btn.closest('.lingo-shopall__item').querySelector('[data-fly-img]');
    if (img && img.currentSrc) dot.style.backgroundImage = 'url("' + img.currentSrc + '")';
    var x0 = from.left + from.width / 2, y0 = from.top + from.height / 2, x1 = to.left + to.width / 2, y1 = to.top + to.height / 2;
    dot.style.left = x0 + 'px'; dot.style.top = y0 + 'px';
    document.body.appendChild(dot);
    var dx = x1 - x0, dy = y1 - y0, lift = Math.min(-60, dy / 3);
    var a = dot.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 + lift) + 'px) scale(.85)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.35)', opacity: .6 }
    ], { duration: 650, easing: 'cubic-bezier(.4,0,.2,1)' });
    return new Promise(function (res) { a.onfinish = a.oncancel = function () { dot.remove(); res(); }; });
  }
  /* The Lingo drawer applies TravelTrio when the cart reaches 3; if that overlaps one of our adds,
     Shopify can drop the code. Once the adds settle, re-check: 3+ non-Met items and no code on the cart -> apply TravelTrio via the
     Ajax API (only when the cart has no other code, so nothing is replaced). */
  var pending = 0, checkTimer;
  function ensureTrio() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var n = 0;
      (cart.items || []).forEach(function (it) { if (it.product_type !== 'Met Deck') n += it.quantity; });
      if (n >= 3 && !(cart.discount_codes && cart.discount_codes.length)) {
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: 'TravelTrio' }) });
      }
    }).catch(function () {});
  }
  function settle() {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(function () { if (pending === 0) { queue = queue.then(ensureTrio).then(syncCart); } }, 900);
  }
  /* Oct 11: smooth "Added" confirmation. The label is never rewritten: a check + "Added" layer fades in over it (same size, no reflow)
     while the button turns green, then both fade back together. Taps on a button that is adding or confirming are ignored, so
     rapid taps can't stack adds or leave the button stuck on "Added". */
  function okOn(b) {
    var o = b.querySelector('.lingo-qa__ok');
    if (!o) { o = document.createElement('span'); o.className = 'lingo-qa__ok'; o.setAttribute('aria-hidden', 'true'); o.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" focusable="false"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>Added'; b.appendChild(o); }
    b.classList.add('is-added');
    clearTimeout(b._t); b._t = setTimeout(function () { b.classList.remove('is-added'); b._t = setTimeout(function () { okOff(b); }, 220); }, 1300);
  }
  function okOff(b) { b._lq = false; b.removeAttribute('aria-disabled'); }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button.lingo-shopall__add'); if (!b) return;
    if (b._lq) return; b._lq = true; b.setAttribute('aria-disabled', 'true');
    pending++;
    var id = parseInt(b.getAttribute('data-variant'), 10), title = b.getAttribute('data-title');
    b.setAttribute('aria-busy', 'true');
    var flying = fly(b);
    if (window.LingoCart && LingoCart.add) { /* Oct 13: same fast path as the quick-add tiles */
      okOn(b); flying.then(bump);
      var im = b.closest('.lingo-shopall__item').querySelector('[data-fly-img]');
      LingoCart.add([{ v: id, q: 1, t: title, y: /US shipping only/.test(b.closest('.lingo-shopall__item').textContent) ? 'Met Deck' : '', i: im && im.currentSrc }], { quiet: true }).then(function () {
        status.textContent = title + ' added to your cart.';
      }, function () {
        clearTimeout(b._t); b.classList.remove('is-added');
        return addOne(id).then(function () { okOn(b); status.textContent = title + ' added to your cart.'; syncCart(); settle(); }, function () { okOff(b); status.textContent = 'Sorry, ' + title + ' could not be added. Please try again.'; });
      }).then(function () { b.removeAttribute('aria-busy'); pending--; });
      return;
    }
    queue = queue.then(function () { return addOne(id); }).then(function () {
      okOn(b);
      status.textContent = title + ' added to your cart.';
      flying.then(bump);
      syncCart();
    }, function () {
      okOff(b);
      status.textContent = 'Sorry, ' + title + ' could not be added. Please try again.';
    }).then(function () { b.removeAttribute('aria-busy'); pending--; if (pending === 0) settle(); });
  });
})();
  });

  /* ---- mobile-gallery (was inline in snippets/lingo-mobile-gallery.liquid) ---- */
  run('mobile-gallery', '[data-lingo-gallery]', function () {
(function () {
  document.querySelectorAll('[data-lingo-gallery]:not([data-lingo-ready])').forEach(function (g) {
    g.setAttribute('data-lingo-ready', '');
    var track = g.querySelector('[data-lingo-gallery-track]');
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-lingo-gallery-slide]'));
    var dots = Array.prototype.slice.call(g.querySelectorAll('[data-lingo-gallery-dot]'));
    var prev = g.querySelector('[data-lingo-gallery-prev]');
    var next = g.querySelector('[data-lingo-gallery-next]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var n = slides.length;
    var loop = n > 1;
    // Looping: clone last before first and first after last. Clones are decorative copies:
    // hidden from assistive tech, not focusable, lazy, never high priority.
    function makeClone(src) {
      var c = src.cloneNode(true);
      c.removeAttribute('data-lingo-gallery-slide');
      c.removeAttribute('role'); c.removeAttribute('aria-roledescription'); c.removeAttribute('aria-label');
      c.setAttribute('data-lingo-clone', ''); c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('img').forEach(function (im) { im.setAttribute('loading', 'lazy'); im.removeAttribute('fetchpriority'); im.setAttribute('alt', ''); });
      c.querySelectorAll('a, button, video, iframe, [tabindex]').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      return c;
    }
    var all = slides;
    if (loop) {
      track.insertBefore(makeClone(slides[n - 1]), slides[0]);
      track.appendChild(makeClone(slides[0]));
      all = Array.prototype.slice.call(track.children);
    }
    var off = loop ? 1 : 0;           // index of real slide 0 inside "all"
    var current = 0;                  // real index (0..n-1)
    var pos = off;                    // position inside "all"
    function left(k) { return all[k].offsetLeft - track.offsetLeft; }
    function jump(k) {                // instant, no animation, no snap fight
      var sb = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = left(k);
      track.style.scrollBehavior = sb;
      pos = k;
    }
    function setActive(i) {
      current = i;
      dots.forEach(function (d, j) { if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (!loop) { if (prev) prev.disabled = i <= 0; if (next) next.disabled = i >= n - 1; }
    }
    function goPos(k) {
      if (!loop) k = Math.max(0, Math.min(n - 1, k));
      k = Math.max(0, Math.min(all.length - 1, k));
      pos = k;
      track.scrollTo({ left: left(k), behavior: reduce ? 'auto' : 'smooth' });
      if (reduce) settle();
    }
    function goTo(i) { goPos(i + off); }
    // Start on the selected image (variant featured media), without animation.
    var start = 0;
    dots.forEach(function (d, j) { if (d.getAttribute('aria-current') === 'true') start = j; });
    jump(start + off);
    setActive(start);
    // When scrolling stops on a clone, jump to the real twin (pixel-identical, so invisible).
    var touching = false;
    function settle() {
      if (!loop || touching) return;
      var k = Math.round(track.scrollLeft / track.clientWidth);
      if (k <= 0) jump(n);
      else if (k >= n + 1) jump(1);
      else pos = k;
    }
    track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    track.addEventListener('touchend', function () { touching = false; }, { passive: true });
    track.addEventListener('touchcancel', function () { touching = false; }, { passive: true });
    var t;
    if ('onscrollend' in window) {
      track.addEventListener('scrollend', function () { touching = false; settle(); });
    }
    // Fallback (Safari without scrollend) and safety net: settle once scrolling pauses.
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (!('IntersectionObserver' in window)) setActive(((Math.round(track.scrollLeft / track.clientWidth) - off) % n + n) % n);
        settle();
      }, 140);
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var k = all.indexOf(e.target);
          setActive(((k - off) % n + n) % n);
        });
      }, { root: track, threshold: 0.6 });
      all.forEach(function (s) { io.observe(s); });
    }
    window.addEventListener('resize', function () { jump(current + off); }, { passive: true });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { goTo(j); }); });
    if (prev) prev.addEventListener('click', function () { goPos(pos - 1); });
    if (next) next.addEventListener('click', function () { goPos(pos + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goPos(pos + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goPos(pos - 1); }
    });
    // Follow variant changes: the theme still marks the selected media on its hidden card pagination.
    var pag = document.querySelector('[data-product-card-pagination]');
    if (pag && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var sel = pag.querySelector('[data-product-card-pagination-selected="true"]');
        if (!sel) return;
        var id = sel.getAttribute('data-product-card-pagination-id');
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === id; });
        if (idx > -1 && idx !== current) goTo(idx);
      }).observe(pag, { attributes: true, subtree: true, attributeFilter: ['data-product-card-pagination-selected'] });
    }
  });

  // Desktop slideshow: thumbnail arrows wrap around. Runs in the capture phase, before the theme's
  // own handler, and only takes over at the ends (last -> first, first -> last).
  if (!window.__lingoThumbWrap) {
    window.__lingoThumbWrap = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-product-slideshow-thumbnails-next], [data-product-slideshow-thumbnails-prev]');
      if (!b) return;
      var wrap = b.closest('[data-product-slideshow-thumbnails-wrapper]');
      if (!wrap) return;
      var th = Array.prototype.slice.call(wrap.querySelectorAll('[data-product-slideshow-thumbnail]'));
      if (th.length < 2) return;
      var sel = th.findIndex(function (x) { return x.classList.contains('product-slideshow-thumbnail-selected'); });
      var isNext = b.hasAttribute('data-product-slideshow-thumbnails-next');
      var target = null;
      if (isNext && sel === th.length - 1) target = th[0];
      if (!isNext && sel === 0) target = th[th.length - 1];
      if (!target) return;
      e.preventDefault(); e.stopImmediatePropagation();
      target.click();
      var strip = wrap.querySelector('[data-product-slideshow-thumbnails]');
      if (strip) strip.scrollTo({ left: isNext ? 0 : strip.scrollWidth, behavior: 'auto' });
    }, true);
  }
})();
  });

  /* ---- peak (was inline in snippets/lingo-peak-scripts.liquid) ---- */
  run('peak', null, function () {
(function () {
  // Click-to-play video
  document.querySelectorAll('[data-lingo-video]').forEach(function (wrap) {
    var v = wrap.querySelector('video');
    var b = wrap.querySelector('[data-lingo-video-play]');
    if (!v) return;
    if (b) b.addEventListener('click', function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    v.addEventListener('play', function () { wrap.classList.add('is-playing'); });
  });

  // Mobile sticky add-to-cart
  var bar = document.querySelector('[data-lingo-sticky-atc]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var form = document.querySelector('.product-main [data-product-form]') || document.querySelector('[data-product-form]');
  if (!form) return;
  var target = form.querySelector('[data-product-form-atc]') || form;
  var btn = bar.querySelector('[data-lingo-sticky-btn]');
  var mq = window.matchMedia('(max-width: 768px)');
  var shown = false;
  function mainBtn() { return form.querySelector('[data-product-submit]') || form.querySelector('[type="submit"]'); }
  function setShown(show) {
    show = show && mq.matches;
    if (show === shown) return;
    shown = show;
    if (show) {
      bar.hidden = false;
      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
      document.documentElement.classList.add('lingo-sticky-on');
    } else {
      bar.classList.remove('is-visible');
      bar.hidden = true;
      document.documentElement.classList.remove('lingo-sticky-on');
    }
  }
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    setShown(!e.isIntersecting && e.boundingClientRect.top < 0);
  }).observe(target);
  /* Oct 11: a jump straight past the button (rating link -> reviews, fast fling, restored scroll) never crosses it, so the
     observer stays silent. One rect read per animation frame while scrolling (phones only) covers that. */
  var tick = false;
  function check() { tick = false; if (!mq.matches) { setShown(false); return; } setShown(target.getBoundingClientRect().bottom < 0); }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', check);
  var mb = mainBtn();
  if (mb && 'MutationObserver' in window) {
    new MutationObserver(function () { btn.disabled = mb.disabled; }).observe(mb, { attributes: true, attributeFilter: ['disabled'] });
  }
  btn.addEventListener('click', function () {
    var m = mainBtn();
    if (m && !m.disabled) { m.click(); return; }
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
  });

  /* ---- cart-drawer (was inline in sections/lingo-cart-drawer.liquid) ---- */
  run('cart-drawer', '#lingo-cd', function () {
(function () {
  if (window.LingoCart) return;
  var data = {}; try { data = JSON.parse(document.getElementById('lingo-cd-data').textContent); } catch (e) {}
  try { localStorage.removeItem('lingo_cart'); } catch (e) {}
  document.documentElement.classList.add('lingo-cart-on');
  var xt = document.querySelector('[data-lcd-express-tpl]'), xc = document.querySelector('[data-lcd-express]');
  if (xt && xc) xc.appendChild(xt.content.cloneNode(true));

  var root = document.getElementById('lingo-cd'), panel = root.querySelector('.lingo-cd__panel');
  var $ = function (s) { return root.querySelector(s); };
  var els = { n: $('[data-lcd-n]'), msg: $('[data-lcd-msg]'), fill: $('[data-lcd-fill]'), m3: $('[data-lcd-m3]'), m5: $('[data-lcd-m5]'), items: $('[data-lcd-items]'), empty: $('[data-lcd-empty]'), ups: $('[data-lcd-ups]'), upsRow: $('[data-lcd-ups-row]'), upsT: $('[data-lcd-ups-t]'), foot: $('[data-lcd-foot]'), saveRow: $('[data-lcd-save-row]'), save: $('[data-lcd-save]'), total: $('[data-lcd-total]'), btnTotal: $('[data-lcd-btn-total]'), met: $('[data-lcd-met]'), status: $('[data-lcd-status]'), checkout: $('[data-lcd-checkout]') };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cart = null, lastFocus = null, queue = Promise.resolve(), known = {};
  /* Optimistic line edits: want[variant id] = quantity the shopper asked for, not yet confirmed by /cart/change.js. */
  var want = {}, timers = {}, inflight = 0, leaving = {}, lockUntil = 0;
  /* Shopify re-keys cart lines when discounts move (TravelTrio), so lines are tracked by variant, not by line key. */
  function uid(it) { return String(it.variant_id) + (it.properties && Object.keys(it.properties).length ? ':' + JSON.stringify(it.properties) : ''); }
  function vq(c, vid) { return (c.items || []).reduce(function (s, x) { return s + (String(x.variant_id) === String(vid) ? x.quantity : 0); }, 0); }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    var a = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','), f = data.fmt || ('$' + '{' + '{amount}' + '}');
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', '#').replace(/,/g, '.').replace('#', ',')).replace(/\{\{\s*\w+\s*\}\}/, a);
  }
  function shortName(t) {
    var s = String(t || '');
    [' Lingo Playing Cards', ' The Metropolitan Museum of Art', ' - The Met x Lingo', ' The Met x Lingo', ' Playing Cards', ' Lingo Cards'].forEach(function (x) { s = s.split(x).join(''); });
    s = s.replace(' Travel Tin', ' Tin').trim();
    return s || t;
  }
  function isMet(it) { return it.product_type === 'Met Deck'; }
  function isProt(it) { return /shipping protection/i.test(it.product_type || '') || it.handle === 'shipping-protection'; }
  function counts(c) {
    var all = 0, elig = 0, met = false;
    (c.items || []).forEach(function (it) { if (isProt(it)) return; all += it.quantity; if (isMet(it)) met = true; else elig += it.quantity; });
    return { all: all, elig: elig, met: met };
  }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function api(url, body) {
    var o = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(body); }
    return fetch(url, o).then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Cart error'); e.data = j; throw e; } return j; }); });
  }
  function setCounts(n) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n > 0 ? n : ''; }); }

  /* TravelTrio: apply only when 3+ eligible items and the cart has NO code at all (never replace another code). */
  function ensureTrio(c) {
    var k = counts(c);
    if (k.elig >= 3 && !(c.discount_codes && c.discount_codes.length)) {
      return api('/cart/update.js', { discount: data.trioCode || 'TravelTrio' }).then(function () { return api('/cart.js'); }).catch(function () { return c; });
    }
    return Promise.resolve(c);
  }
  function load(opts) {
    return queue = queue.then(function () { return api('/cart.js'); }).then(ensureTrio).then(function (c) { render(c, opts || {}); return c; }).catch(function () {});
  }

  function progress(k) {
    var pct = Math.min(k.all, 5) / 5 * 100, m;
    if (k.all === 0) m = 'Buy 2, get 1 free. Free shipping on 5+ items.';
    else if (k.elig < 3) {
      var need = 3 - k.elig;
      m = 'Add <strong>' + need + ' more deck' + (need > 1 ? 's' : '') + '</strong> and one is free.' + (k.met ? ' Met decks don\u2019t count toward this offer.' : '');
      if (k.all >= 5) m = '<strong>Free shipping unlocked.</strong> ' + m;
    } else if (k.all < 5) {
      var n5 = 5 - k.all; m = '<strong>Free deck unlocked.</strong> Add ' + n5 + ' more item' + (n5 > 1 ? 's' : '') + ' for free shipping.';
    } else m = '<strong>Free deck and free shipping unlocked.</strong> Free shipping is applied at checkout.';
    els.msg.innerHTML = m;
    els.fill.style.width = pct + '%';
    els.m3.classList.toggle('is-done', k.elig >= 3);
    els.m5.classList.toggle('is-done', k.all >= 5);
  }

  function lineHTML(it, i) {
    var name = shortName(it.product_title), freeQty = 0;
    var disc = (it.line_level_discount_allocations || []).reduce(function (s, d) { return s + d.amount; }, 0);
    var orig = it.original_line_price, fin = it.final_line_price;
    if (disc > 0 && it.final_price === 0) freeQty = it.quantity;
    var tag = '';
    var nfree = it.original_price ? Math.floor((disc + 1) / it.original_price) : 0;
    if (disc > 0) tag = '<span class="lingo-cd__tag lingo-cd__tag--free">' + (fin === 0 ? 'Free' : (nfree >= 1 ? nfree + ' free' : 'Discount applied')) + '</span>';
    if (isMet(it)) tag += '<span class="lingo-cd__tag">US shipping only</span>';
    var variant = (it.variant_title && !/^default title$/i.test(it.variant_title)) ? '<span class="lingo-cd__var">' + esc(it.variant_title) + '</span>' : '';
    var im = it.image ? '<img class="lingo-cd__img" src="' + esc(img(it.image, 160)) + '" srcset="' + esc(img(it.image, 160)) + ' 1x, ' + esc(img(it.image, 240)) + ' 2x" width="76" height="76" alt="" loading="lazy">' : '<span class="lingo-cd__img"></span>';
    return '<li class="lingo-cd__item' + (known[uid(it)] ? '' : ' is-new') + '" data-key="' + esc(it.key) + '" data-uid="' + esc(uid(it)) + '" data-vid="' + it.variant_id + '">' +
      '<a href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + im + '</a>' +
      '<div><a class="lingo-cd__name" href="' + esc(it.url) + '"><span aria-hidden="true">' + esc(name) + '</span><span class="lingo-sr">' + esc(it.product_title) + '</span></a>' + variant + tag +
      '<div class="lingo-cd__qty" role="group" aria-label="Quantity, ' + esc(it.product_title) + '">' +
      '<button type="button" class="lingo-cd__qb" data-q="-1" aria-label="Decrease quantity of ' + esc(it.product_title) + '">\u2212</button>' +
      '<span class="lingo-cd__qv" aria-live="polite">' + it.quantity + '</span>' +
      '<button type="button" class="lingo-cd__qb" data-q="1" aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button></div></div>' +
      '<div class="lingo-cd__right"><span class="lingo-cd__price">' + (disc > 0 ? '<s><span class="lingo-sr">Was </span>' + money(orig) + '</s><span class="lingo-sr">Now </span>' : '') + money(fin) + '</span>' +
      '<button type="button" class="lingo-cd__rm" data-rm aria-label="Remove ' + esc(it.product_title) + '">Remove</button></div></li>';
  }

  /* Upsell heading from the same remaining-to-threshold counts as the progress bar (runs on optimistic renders too). */
  function upsTitle(k) {
    if (k.all === 0) return 'Popular picks';
    if (k.elig < 3) { var nd = 3 - k.elig; return nd === 1 ? 'Add 1 more deck and one is free' : 'Complete your trio'; }
    if (k.all < 5) { var n5 = 5 - k.all; return 'Add ' + n5 + ' more for free shipping'; }
    return 'You might also like';
  }
  function renderUps(c) {
    var inCart = {}; (c.items || []).forEach(function (it) { inCart[it.variant_id] = 1; });
    var list = (data.ups || []).filter(function (u) { return !inCart[u.v]; }).slice(0, 6);
    els.ups.hidden = !list.length;
    var k = counts(c);
    els.upsT.textContent = upsTitle(k);
    els.upsRow.innerHTML = list.map(function (u) {
      return '<li class="lingo-cd__up"><img src="' + esc(u.i) + '" width="120" height="120" alt="" loading="lazy">' +
        '<span class="lingo-cd__up-n" aria-hidden="true">' + esc(u.s) + '</span><span class="lingo-cd__up-p" aria-hidden="true">' + money(u.p) + '</span>' +
        '<button type="button" class="lingo-cd__up-add" data-up="' + u.v + '" aria-label="Add ' + esc(u.t) + ', ' + esc(money(u.p)) + '">Add</button></li>';
    }).join('');
  }

  function render(c, opts) {
    opts = opts || {};
    if (!opts.optimistic && (inflight > 0 || Object.keys(timers).length)) { cart = c; return; } /* a newer edit is still pending: wait, so lines never flicker back */
    if (!opts.optimistic) cart = c;
    var k = counts(c), items = merge(c.items || []);
    els.n.textContent = c.item_count > 0 ? c.item_count : '';
    setCounts(c.item_count);
    progress(k);
    reconcile(items);
    known = {}; items.forEach(function (it) { known[uid(it)] = 1; });
    els.empty.hidden = items.length > 0;
    els.foot.hidden = items.length === 0;
    [els.total, els.save].forEach(function (x) { x.classList.toggle('is-syncing', !!opts.optimistic); });
    els.total.textContent = money(c.total_price);
    els.btnTotal.textContent = items.length ? money(c.total_price) : '';
    var save = c.total_discount || 0;
    els.saveRow.hidden = !(save > 0); els.save.textContent = save > 0 ? money(save) : '';
    els.met.hidden = !k.met;
    renderUps(c);
    if (opts.focusKey) { var b = els.items.querySelector('[data-key="' + opts.focusKey + '"] [data-q="' + opts.focusQ + '"]'); if (b) b.focus(); }
    if (!items.length && opts.fromItem) els.empty.querySelector('a').focus();
    else if (opts.focusTitle || (opts.fromItem && !opts.focusKey)) { var h = root.querySelector('#lingo-cd-title'); if (h) h.focus({ preventScroll: true }); }
    if (!opts.optimistic) document.dispatchEvent(new CustomEvent('lingo:cart', { detail: c }));
  }

  /* Shopify can split one variant into two lines when a free deck is allocated; show it as one line. */
  function merge(list) {
    var out = [], at = {};
    list.forEach(function (it) {
      var u = uid(it), m = at[u];
      if (!m) { m = at[u] = JSON.parse(JSON.stringify(it)); out.push(m); return; }
      m.quantity += it.quantity; m.original_line_price += it.original_line_price; m.final_line_price += it.final_line_price;
      m.line_level_discount_allocations = (m.line_level_discount_allocations || []).concat(it.line_level_discount_allocations || []);
    });
    return out;
  }
  /* Keyed update of the line list: unchanged lines stay in place, removed lines animate out, new lines animate in. */
  function reconcile(items) {
    var have = {}; Array.prototype.forEach.call(els.items.children, function (li) { have[li.getAttribute('data-uid')] = li; });
    var keep = {}, prev = null, seen = {};
    items.forEach(function (it, i) {
      var u = uid(it); seen[u] = (seen[u] || 0) + 1; var id = seen[u] > 1 ? u + '#' + seen[u] : u;
      keep[id] = 1;
      var html = lineHTML(it, i).replace('data-uid="' + esc(u) + '"', 'data-uid="' + esc(id) + '"'), li = have[id];
      if (li && leaving[id]) { li.remove(); li = null; delete leaving[id]; } /* server restored a line we were removing (error path) */
      if (!li) { var t = document.createElement('template'); t.innerHTML = html; li = t.content.firstChild; }
      else if (li.getAttribute('data-h') !== html) {
        var f = document.activeElement && li.contains(document.activeElement) ? document.activeElement.getAttribute('data-q') || (document.activeElement.hasAttribute('data-rm') ? 'rm' : null) : null;
        var t2 = document.createElement('template'); t2.innerHTML = html; var n = t2.content.firstChild; n.classList.remove('is-new');
        li.className = n.className; li.setAttribute('data-key', n.getAttribute('data-key')); li.innerHTML = n.innerHTML; /* update in place: no node swap, no flash */
        if (f) { var fb = li.querySelector(f === 'rm' ? '[data-rm]' : '[data-q="' + f + '"]'); if (fb) fb.focus({ preventScroll: true }); }
      }
      li.setAttribute('data-h', html);
      if (want[it.variant_id] != null) li.classList.add('is-syncing'); else li.classList.remove('is-syncing');
      var at = prev ? prev.nextSibling : els.items.firstChild;
      if (at !== li) els.items.insertBefore(li, at);
      prev = li;
    });
    Object.keys(have).forEach(function (k) { if (!keep[k] && !leaving[k]) poofOut(have[k]); });
  }
  function puff(x, y) {
    if (reduce.matches) return;
    for (var i = 0; i < 8; i++) {
      var p = document.createElement('span'), a = (Math.PI * 2 * i) / 8 + Math.random() * .4, d = 18 + Math.random() * 16;
      p.className = 'lingo-cd__puff'; p.style.left = x + 'px'; p.style.top = y + 'px';
      p.style.setProperty('--dx', Math.cos(a) * d + 'px'); p.style.setProperty('--dy', Math.sin(a) * d + 'px');
      document.body.appendChild(p); setTimeout(function (n) { n.remove(); }.bind(null, p), 500);
    }
  }
  function poofOut(li, from) {
    var key = li.getAttribute('data-uid'); if (leaving[key]) return; leaving[key] = 1;
    if (from) { var r = from.getBoundingClientRect(); puff(r.left + r.width / 2, r.top + r.height / 2); }
    if (reduce.matches) { li.remove(); delete leaving[key]; return; }
    li.style.height = li.offsetHeight + 'px'; void li.offsetHeight;
    li.classList.add('is-leaving'); li.style.height = '0px';
    setTimeout(function () { if (leaving[key]) { li.remove(); delete leaving[key]; } }, 270);
  }
  /* Local estimate of the cart after an edit (totals/progress move instantly; the server's numbers replace it a moment later). */
  function estimate() {
    var c = JSON.parse(JSON.stringify(cart)), done = {};
    c.items = c.items.filter(function (it) {
      var w = want[it.variant_id];
      if (w == null) return true;
      if (done[it.variant_id]) return false; /* extra lines of the same variant fold into the first */
      done[it.variant_id] = 1;
      if (w === 0) return false;
      it.quantity = w; it.original_line_price = it.original_price * w; it.final_line_price = it.original_line_price; it.line_level_discount_allocations = [];
      return true;
    });
    /* TravelTrio estimate: for every 3 eligible (non-Met) decks the cheapest one is free; the server's numbers replace this a moment later */
    var units = [], cnt = 0, orig = 0;
    c.items.forEach(function (it) { cnt += it.quantity; orig += it.original_line_price; if (!isMet(it) && !isProt(it)) for (var q = 0; q < it.quantity; q++) units.push(it.original_price); });
    units.sort(function (a, b) { return a - b; });
    var free = 0, nf = Math.floor(units.length / 3);
    if (cart.discount_codes && cart.discount_codes.length && !cart.discount_codes.some(function (d) { return /traveltrio/i.test(d.code); })) nf = 0; /* another code: don't guess */
    for (var f = 0; f < nf; f++) free += units[f];
    c.item_count = cnt; c.total_discount = free; c.total_price = orig - free;
    return c;
  }
  function edit(vid, nq, from, li) {
    var it = (cart.items || []).filter(function (x) { return String(x.variant_id) === String(vid); })[0]; if (!it) return;
    var key = vid; want[vid] = nq;
    if (nq === 0) { els.items.querySelectorAll('[data-vid="' + vid + '"]').forEach(function (l) { poofOut(l, l === li ? from : null); }); }
    else if (li) { var qv = li.querySelector('.lingo-cd__qv'); if (qv) { qv.textContent = nq; qv.classList.remove('is-bump'); void qv.offsetWidth; qv.classList.add('is-bump'); } }
    render(estimate(), { optimistic: true });
    clearTimeout(timers[key]);
    /* qty taps are batched (one request for a burst of +/-); removals go straight away */
    timers[key] = setTimeout(function () { delete timers[key]; send(key, it.product_title); }, nq === 0 ? 0 : 320);
  }
  function send(key, title) {
    var nq = want[key]; inflight++;
    /* Oct 13: change straight from the drawer's cart (one request); if those line keys are out of date, re-read the cart first as before */
    function viaFresh() { return api('/cart.js'); }
    queue = queue.then(function () {
      var known = cart && (cart.items || []).filter(function (x) { return String(x.variant_id) === String(key); });
      if (!known || !known.length) return viaFresh();
      var ups = {}; known.forEach(function (l, i) { ups[l.key] = i === 0 ? nq : 0; });
      return api('/cart/update.js', { updates: ups }).then(function (c) { c.__done = true; return c; }, viaFresh);
    }).then(function (fresh) {
      if (fresh.__done) return fresh;
      var lines = (fresh.items || []).filter(function (x) { return String(x.variant_id) === String(key); });
      if (!lines.length) return fresh;
      /* Several lines of one variant (TravelTrio splits free and paid units): set them all in ONE /cart/update.js call,
         first line = the full amount, the rest = 0. Oct 11: the old one-line-at-a-time version let Shopify re-split the
         lines between calls, so a minus tap could ADD decks (6 -> 8). */
      var ups = {}; lines.forEach(function (l, i) { ups[l.key] = i === 0 ? nq : 0; });
      return api('/cart/update.js', { updates: ups });
    }).then(function (c) {
      inflight--; if (want[key] === nq) delete want[key];
      var gq = vq(c, key);
      if (nq > 0 && gq < nq) toast('Only ' + gq + ' of ' + shortName(title) + ' available.');
      els.status.textContent = nq === 0 ? title + ' removed from your cart.' : 'Quantity of ' + title + ' is now ' + gq + '.';
      return ensureTrio(c);
    }, function (err) {
      inflight--; delete want[key];
      toast(nq === 0 ? 'Couldn\u2019t remove ' + shortName(title) + '. Please try again.' : 'Couldn\u2019t update ' + shortName(title) + '. ' + (err.message || ''));
      return api('/cart.js');
    }).then(function (c) { if (c) { if (!(inflight > 0 || Object.keys(timers).length)) render(c, { fromItem: true }); else cart = c; } }).catch(function () {});
  }
  var toastT;
  function toast(m) {
    var t = root.querySelector('.lingo-cd__toast');
    if (!t) { t = document.createElement('p'); t.className = 'lingo-cd__toast'; t.setAttribute('role', 'alert'); els.items.parentNode.insertBefore(t, els.items); }
    t.textContent = m; t.hidden = false; clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 4000);
  }

  function focusables() { return Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])'), function (e) { return e.offsetParent !== null || e === document.activeElement; }); }
  function open(noLoad) {
    if (root.classList.contains('is-open')) { if (noLoad !== true) load(); return; }
    lastFocus = document.activeElement;
    root.hidden = false; document.documentElement.classList.add('lingo-cd-lock'); document.body.classList.add('lingo-cart-open'); document.dispatchEvent(new CustomEvent('lingo:cart-open'));
    void panel.offsetWidth;
    root.classList.add('is-open');
    setTimeout(function () { var x = root.querySelector('.lingo-cd__x'); (x || panel).focus({ preventScroll: true }); }, reduce.matches ? 0 : 60);
    if (noLoad !== true) load();
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open'); document.documentElement.classList.remove('lingo-cd-lock'); document.dispatchEvent(new CustomEvent('lingo:cart-close'));
    var done = function () { if (!root.classList.contains('is-open')) root.hidden = true; };
    if (reduce.matches) done(); else setTimeout(done, 340);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-lcd-close]')) { close(); return; }
    var qb = t.closest('[data-q]'), rm = t.closest('[data-rm]'), up = t.closest('[data-up]');
    if (qb || rm) {
      var li = t.closest('[data-uid]'), vid = li.getAttribute('data-vid');
      if (Date.now() < lockUntil || leaving[li.getAttribute('data-uid')] || want[vid] === 0) return; /* ignore double taps and taps on a line that slid under the finger */
      if (!(cart.items || []).some(function (x) { return String(x.variant_id) === vid; })) return;
      var cur = want[vid] != null ? want[vid] : vq(cart, vid);
      var nq = rm ? 0 : Math.max(0, cur + parseInt(qb.getAttribute('data-q'), 10));
      if (nq === 0) { lockUntil = Date.now() + 450; var nb = li.nextElementSibling || li.previousElementSibling; setTimeout(function () { var f = nb && nb.querySelector('[data-rm]'); if (f) f.focus({ preventScroll: true }); else { var h = root.querySelector('#lingo-cd-title'); if (h) h.focus({ preventScroll: true }); } }, 280); }
      edit(vid, nq, rm || qb, li);
      return;
    }
    if (up) {
      up.disabled = true; up.textContent = 'Adding\u2026';
      /* Oct 13: the upsell joins the cart on the tap (estimate), one request confirms */
      var uv = parseInt(up.getAttribute('data-up'), 10), ud = (data.ups || []).filter(function (x) { return x.v === uv; })[0] || {};
      add([{ v: uv, q: 1, t: ud.t, p: ud.p, i: ud.i }], {}).then(function () { els.status.textContent = (ud.t || 'Item') + ' added to your cart.'; var h = root.querySelector('#lingo-cd-title'); if (h) h.focus({ preventScroll: true }); }, function (err) {
        if (err && err.cart) { toast(err.message); return; }
        queue = queue.then(function () { return api('/cart/add.js', { items: [{ id: uv, quantity: 1 }] }); }).then(function (r) {
          var t0 = (r.items && r.items[0] && r.items[0].product_title) || 'Item'; els.status.textContent = t0 + ' added to your cart.';
        }).catch(function (err) { els.status.textContent = err.message; });
        load({ focusTitle: true });
      });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Cart icons / cart links open the drawer (except on the cart page itself and links inside the drawer). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lingo-cart], [data-header-drawer-toggle="cart"], a[href="/cart"], a[href^="/cart?"]');
    if (!a || root.contains(a) || /^\/cart\/?$/.test(location.pathname)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault(); e.stopPropagation(); open();
  }, true);

  /* Product page Add to cart (theme form + sticky bar, which clicks the theme button): add via Ajax, then open the drawer. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || root.contains(f)) return;
    e.preventDefault(); e.stopPropagation();
    var btn = f.querySelector('[type="submit"]'); if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(f); if (!fd.get('quantity')) fd.set('quantity', '1');
    /* Oct 13: fast path for a plain variant + quantity form: the drawer opens on the tap with the item in it, one request confirms.
       Forms with line item properties or selling plans, or any failure, use the original add below. */
    var plain = !!fd.get('id');
    fd.forEach(function (v, k) { if (!/^(id|quantity|form_type|utf8|product-id|section-id|return_to)$/.test(k)) plain = false; });
    var meta = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || null;
    if (plain && meta && !f._slow) {
      var vid = parseInt(fd.get('id'), 10), qn = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
      var mv = (meta.variants || []).filter(function (x) { return x.id === vid; })[0] || {}, h1 = document.querySelector('h1'), og = document.querySelector('meta[property="og:image"]');
      add([{ v: vid, q: qn, t: (h1 && h1.textContent.trim()) || mv.name || 'Item', p: mv.price || 0, y: meta.type || '', i: og && og.content.replace(/^http:/, 'https:'), u: location.pathname }], { open: true }).then(function (c) {
        els.status.textContent = ((h1 && h1.textContent.trim()) || 'Item') + ' added to your cart.';
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      }, function (err) {
        if (err && err.cart) { toast(err.message); if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } return; }
        f._slow = true; if (btn) btn.disabled = false; if (f.requestSubmit) f.requestSubmit(btn || undefined); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); f._slow = false;
      });
      return;
    }
    queue = queue.then(function () {
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); });
    }).then(function () { open(); }, function (err) { open(); setTimeout(function () { els.status.textContent = err.message; els.msg.textContent = err.message; }, 400); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }, true);

  /* Quick-add tiles call LingoCart.refresh() after their adds: that refreshes this drawer's data without opening it. */
  /* Oct 13: Surprise me fast path. picks = 3 decks from the page's pool ({v, t, y, h, u, p, i}).
     1) the drawer opens on the same frame with the 3 decks already in it and the cheapest eligible unit marked Free (an estimate,
        shown as syncing); 2) ONE /cart/update.js call adds all 3 and applies TravelTrio (only when the cart has no code) and
        returns the cart, which replaces the estimate. If any deck didn't make it into the cart, it re-reads /cart.js. */
  function surprise(picks) {
    var base = cart || { items: [], discount_codes: [], item_count: 0 };
    var c = JSON.parse(JSON.stringify(base)); c.items = c.items || [];
    picks.forEach(function (p) {
      var ex = c.items.filter(function (x) { return String(x.variant_id) === String(p.v); })[0];
      if (ex) { ex.quantity++; ex.original_line_price += ex.original_price; ex.final_line_price += ex.original_price; return; }
      c.items.unshift({ key: 'opt-' + p.v, variant_id: p.v, product_title: p.t, product_type: p.y, handle: p.h, url: p.u, image: p.i, quantity: 1,
        original_price: p.p, final_price: p.p, original_line_price: p.p, final_line_price: p.p, line_level_discount_allocations: [], properties: {}, variant_title: null });
    });
    var other = base.discount_codes && base.discount_codes.some(function (d) { return d.applicable !== false && !/traveltrio/i.test(d.code); });
    var units = [], cnt = 0, orig = 0;
    c.items.forEach(function (it) { cnt += it.quantity; orig += it.original_line_price; if (!isMet(it) && !isProt(it)) for (var q = 0; q < it.quantity; q++) units.push(it); });
    units.sort(function (a, b) { return a.original_price - b.original_price; });
    var nf = other ? 0 : Math.floor(units.length / 3), free = 0;
    c.items.forEach(function (it) { it.line_level_discount_allocations = []; it.final_line_price = it.original_line_price; it.final_price = it.original_price; });
    for (var f = 0; f < nf; f++) { var it = units[f]; it.line_level_discount_allocations.push({ amount: it.original_price }); it.final_line_price -= it.original_price; free += it.original_price; if (it.quantity === 1) it.final_price = 0; }
    c.item_count = cnt; c.total_discount = free; c.total_price = orig - free;
    open(true); render(c, { optimistic: true });
    return queue = queue.then(function () {
      var now = cart || base, body = { updates: {} };
      picks.forEach(function (p) { body.updates[p.v] = vq(now, p.v) + 1; });
      if (!(now.discount_codes && now.discount_codes.length)) body.discount = data.trioCode || 'TravelTrio';
      return api('/cart/update.js', body).then(function (fc) {
        var ok = picks.every(function (p) { return vq(fc, p.v) >= 1; });
        return ok ? fc : api('/cart.js');
      });
    }).then(function (fc) { render(fc, {}); return fc; }, function (e) { load(); throw e; });
  }

  /* Oct 13: fast add for every Add button. picks = [{v: variant id, q: qty, t: title, p: price (cents), i: image, y: product type, u: url}].
     The count (and the drawer, when it's open or opts.open) update on the tap from an estimate; then ONE /cart/update.js call adds
     the items, applies TravelTrio when the cart reaches 3 eligible decks and has no code, and returns the cart that replaces the estimate.
     Variants already in the cart are set by line key (first line = new total, extra split lines = 0), like the qty stepper. */
  var adding = 0;
  function estAdd(base, picks) {
    var c = JSON.parse(JSON.stringify(base)); c.items = c.items || [];
    picks.forEach(function (p) {
      var ex = c.items.filter(function (x) { return String(x.variant_id) === String(p.v); })[0];
      if (ex) { ex.quantity += p.q; ex.original_line_price += ex.original_price * p.q; return; }
      c.items.unshift({ key: 'opt-' + p.v, variant_id: p.v, product_title: p.t || 'Item', product_type: p.y || '', handle: '', url: p.u || '#', image: p.i || '', quantity: p.q,
        original_price: p.p || 0, final_price: p.p || 0, original_line_price: (p.p || 0) * p.q, final_line_price: (p.p || 0) * p.q, line_level_discount_allocations: [], properties: {}, variant_title: null });
    });
    var other = base.discount_codes && base.discount_codes.some(function (d) { return d.applicable !== false && !/traveltrio/i.test(d.code); });
    var units = [], cnt = 0, orig = 0;
    c.items.forEach(function (it) { it.line_level_discount_allocations = []; it.final_line_price = it.original_line_price; it.final_price = it.original_price; cnt += it.quantity; orig += it.original_line_price; if (!isMet(it) && !isProt(it)) for (var q = 0; q < it.quantity; q++) units.push(it); });
    units.sort(function (a, b) { return a.original_price - b.original_price; });
    var nf = other ? 0 : Math.floor(units.length / 3), free = 0;
    for (var f = 0; f < nf; f++) { var it = units[f]; it.line_level_discount_allocations.push({ amount: it.original_price }); it.final_line_price -= it.original_price; free += it.original_price; if (it.quantity === 1) it.final_price = 0; }
    c.item_count = cnt; c.total_discount = free; c.total_price = orig - free;
    return c;
  }
  function add(picks, opts) {
    opts = opts || {};
    var base = cart || { items: [], discount_codes: [], item_count: 0 }, q0 = picks.reduce(function (s, p) { return s + p.q; }, 0);
    adding += q0; if (cart) setCounts((base.item_count || 0) + adding);
    if (opts.open) open(true);
    if (opts.open || root.classList.contains('is-open')) render(estAdd(base, picks), { optimistic: true });
    var res = queue.then(function () {
      var now = cart || base, body = { updates: {} };
      picks.forEach(function (p) {
        var lines = (now.items || []).filter(function (x) { return String(x.variant_id) === String(p.v); });
        if (!lines.length) body.updates[p.v] = (body.updates[p.v] || 0) + p.q;
        else { var tot = vq(now, p.v); lines.forEach(function (l, i) { body.updates[l.key] = i === 0 ? tot + p.q : 0; }); }
      });
      var k = counts(now), plus = picks.reduce(function (s, p) { return s + (p.y === 'Met Deck' ? 0 : p.q); }, 0);
      if (!(now.discount_codes && now.discount_codes.length) && k.elig + plus >= 3) body.discount = data.trioCode || 'TravelTrio';
      return api('/cart/update.js', body).then(function (fc) {
        var short = picks.filter(function (p) { return vq(fc, p.v) < vq(now, p.v) + p.q; });
        if (short.length) { var g = vq(fc, short[0].v) - vq(now, short[0].v); if (g <= 0) { var e = new Error('Sorry, ' + (short[0].t || 'that item') + ' is sold out.'); e.cart = fc; throw e; } toast('Only ' + g + ' more of ' + shortName(short[0].t) + ' available.'); }
        return ensureTrio(fc);
      });
    });
    queue = res.catch(function () {});
    return res.then(function (fc) { adding -= q0; render(fc, {}); return fc; }, function (e) { adding -= q0; if (e.cart) render(e.cart, {}); else load(); throw e; });
  }

  window.LingoCart = { on: true, open: open, close: close, refresh: load, surprise: surprise, add: add, get cart() { return cart; } };
  window.addEventListener('pageshow', function (e) { if (e.persisted) load(); });
  load();
})();
  });
})();
